/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import { Toolbar } from "primereact/toolbar"
import { Toast } from "primereact/toast"
import PropTypes from "prop-types"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { confirmation } from "../../../types/dropDownTypes"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
} from "../../../utils/utils"
import { errorMessages } from "../../../types/messages"
import ServicesRow from "./ServicesRow"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { InputText } from "primereact/inputtext"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const Services2 = (props) => {
  const { showToolBar, disabled } = props

  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [plannedServices2, setPlannedServices2] = useState(
    interview[INTERVIEW_SECTIONS.PLANNED_SERVICES_2]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) => q.section === INTERVIEW_SECTIONS.PLANNED_SERVICES_2
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.PLANNED_SERVICES_2
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    updateInterviewValues(
      INTERVIEW_SECTIONS.PLANNED_SERVICES_2,
      plannedServices2
    )
    if (prevForm) {
      handleLoadPrev(true)
      setNextForm(sections[activeIndex - 1].section)
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_SERVICES2_DATA, {
          GpraBServicesTs1: plannedServices2?.gpra_b_services_ts_1,
          GpraBServicesTs2: plannedServices2?.gpra_b_services_ts_2,
          GpraBServicesTs3: plannedServices2?.gpra_b_services_ts_3,
          GpraBServicesTs4: plannedServices2?.gpra_b_services_ts_4,
          GpraBServicesTs5: plannedServices2?.gpra_b_services_ts_5,
          GpraBServicesTs6: plannedServices2?.gpra_b_services_ts_6,
          GpraBServicesTs7: plannedServices2?.gpra_b_services_ts_7,
          GpraBServicesTs8: plannedServices2?.gpra_b_services_ts_8,
          GpraBServicesTs9: plannedServices2?.gpra_b_services_ts_9,
          GpraBServicesTs10: plannedServices2?.gpra_b_services_ts_10,
          GpraBServicesTs11: plannedServices2?.gpra_b_services_ts_11,
          GpraBServicesTs12: plannedServices2?.gpra_b_services_ts_12,
          GpraBServicesTs13: plannedServices2?.gpra_b_services_ts_13,
          GpraBServicesTs14: plannedServices2?.gpra_b_services_ts_14,
          GpraBServicesTs15: plannedServices2?.gpra_b_services_ts_15,
          GpraBServicesTs16: plannedServices2?.gpra_b_services_ts_16,
          GpraBServicesTs17: plannedServices2?.gpra_b_services_ts_17,
          GpraBServicesTs18: plannedServices2?.gpra_b_services_ts_18,
          GpraBServicesTs18a: plannedServices2?.gpra_b_services_ts_18a,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraBServicesId: plannedServices2?.gpra_b_services_id,
          Additional: getAdditionalQuestions(plannedServices2),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              handleLoadNext(false)
              setNextForm(sections[activeIndex + 1].section)
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ plannedServices2: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (
      plannedServices2?.gpra_b_services_ts_1 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_1 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_2 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_2 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_3 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_3 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_4 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_4 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_5 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_5 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_6 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_6 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_7 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_7 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_8 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_8 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_9 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_9 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_10 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_10 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_11 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_11 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_12 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_12 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_13 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_13 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_14 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_14 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_15 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_15 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_16 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_16 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_17 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_17 = errorMessages.requiredMessage
    }
    if (
      plannedServices2?.gpra_b_services_ts_18 === undefined &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      errors.gpra_b_services_ts_18 = errorMessages.requiredMessage
    } else if (
      plannedServices2?.gpra_b_services_ts_18 &&
      showQuestion(questions, "gpra_b_services_ts_1")
    ) {
      if (!plannedServices2?.gpra_b_services_ts_18a) {
        errors.gpra_b_services_ts_18a = errorMessages.requiredMessage
      }
    }
    setValidationErrors(
      validateQuestions(
        plannedServices2,
        INTERVIEW_SECTIONS.PLANNED_SERVICES_2,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_b_services_ts_1") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Treatment Services`} />
          </div>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={
                " [SBIRT GRANTS: You must PROVIDE at least one of the Treatment Services numbered 1 through 4.]"
              }
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`1. Screening`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_1}
              setDrop={"gpra_b_services_ts_1"}
              dropError={validationErrors.gpra_b_services_ts_1}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`2. Brief Intervention`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_2}
              setDrop={"gpra_b_services_ts_2"}
              dropError={validationErrors.gpra_b_services_ts_2}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`3. Brief Treatment`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_3}
              setDrop={"gpra_b_services_ts_3"}
              dropError={validationErrors.gpra_b_services_ts_3}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`4. Referral to Treatment`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_4}
              setDrop={"gpra_b_services_ts_4"}
              dropError={validationErrors.gpra_b_services_ts_4}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`5. Assessment`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_5}
              setDrop={"gpra_b_services_ts_5"}
              dropError={validationErrors.gpra_b_services_ts_5}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`6. Treatment Planning`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_6}
              setDrop={"gpra_b_services_ts_6"}
              dropError={validationErrors.gpra_b_services_ts_6}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`7. Recovery Planning`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_7}
              setDrop={"gpra_b_services_ts_7"}
              dropError={validationErrors.gpra_b_services_ts_7}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`8. Individual Counseling`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_8}
              setDrop={"gpra_b_services_ts_8"}
              dropError={validationErrors.gpra_b_services_ts_8}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`9. Group Counseling`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_9}
              setDrop={"gpra_b_services_ts_9"}
              dropError={validationErrors.gpra_b_services_ts_9}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`10. Contingency Management`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_10}
              setDrop={"gpra_b_services_ts_10"}
              dropError={validationErrors.gpra_b_services_ts_10}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`11. Community Reinforcement`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_11}
              setDrop={"gpra_b_services_ts_11"}
              dropError={validationErrors.gpra_b_services_ts_11}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`12. Cognitive Behavioral Therapy`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_12}
              setDrop={"gpra_b_services_ts_12"}
              dropError={validationErrors.gpra_b_services_ts_12}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`13. Family/Marriage Counseling`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_13}
              setDrop={"gpra_b_services_ts_13"}
              dropError={validationErrors.gpra_b_services_ts_13}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`14. Co-Occurring Treatment Services`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_14}
              setDrop={"gpra_b_services_ts_14"}
              dropError={validationErrors.gpra_b_services_ts_14}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`15. Pharmacological Interventions`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_15}
              setDrop={"gpra_b_services_ts_15"}
              dropError={validationErrors.gpra_b_services_ts_15}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`16. HIV/AIDS Counseling`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_16}
              setDrop={"gpra_b_services_ts_16"}
              dropError={validationErrors.gpra_b_services_ts_16}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`17. Cultural Interventions/Activities`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_17}
              setDrop={"gpra_b_services_ts_17"}
              dropError={validationErrors.gpra_b_services_ts_17}
              summaryDisabled={disabled}
              required
            />
          </div>
          <div className={gpraStyles.formServicesRow}>
            <ServicesRow
              entity={plannedServices2}
              setEntity={setPlannedServices2}
              showNumber={false}
              removeError={removeError}
              label={`18. Other Clinical Services (Specify)`}
              options={confirmation}
              drop={plannedServices2?.gpra_b_services_ts_18}
              setDrop={"gpra_b_services_ts_18"}
              dropError={validationErrors.gpra_b_services_ts_18}
              extraValues={[{ key: "gpra_b_services_ts_18a", value: "" }]}
              summaryDisabled={disabled}
              multipleErrors
              errorsToRemove={["gpra_b_services_ts_18a"]}
              required
            />
          </div>
          {plannedServices2?.gpra_b_services_ts_18 && (
            <div className={gpraStyles.formServicesRow}>
              <InputText
                className={
                  validationErrors.gpra_b_services_ts_18a
                    ? gpraStyles.inputText5Error
                    : gpraStyles.inputText5
                }
                disabled={!plannedServices2?.gpra_b_services_ts_18 || disabled}
                placeholder={
                  !plannedServices2?.gpra_b_services_ts_18
                    ? "Not Applicable"
                    : ""
                }
                value={plannedServices2?.gpra_b_services_ts_18a}
                onChange={(e) => {
                  updateState(
                    "gpra_b_services_ts_18a",
                    e.target.value,
                    null,
                    null,
                    plannedServices2,
                    setPlannedServices2,
                    null
                  )
                  removeError("gpra_b_services_ts_18a")
                }}
              />
              <FormError error={validationErrors.gpra_b_services_ts_18a} />
            </div>
          )}
        </>
      )
    }
  }

  return (
    <>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset
        legend="B. SUBSTANCE USE AND PLANNED SERVICES"
        style={{ marginBottom: "1rem" }}
      >
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <div
                    style={{
                      marginLeft: "0.5rem",
                      width: "100%",
                      marginTop: "1rem",
                    }}
                  >
                    <AdditionalQuestionContainer
                      entity={plannedServices2}
                      setEntity={setPlannedServices2}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.PLANNED_SERVICES_2}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  </div>
                )
              } else {
                if (checkDisplayConditional(question, plannedServices2)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={plannedServices2}
                      setEntity={setPlannedServices2}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.PLANNED_SERVICES_2}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mt2}
          right={
            <CustomToolBar
              prevForm={true}
              nextForm={true}
              saveData={saveData}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
    </>
  )
}

Services2.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Services2.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Services2
